import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "seo";
var seoService = {
    linkKontrol(link) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                link: link,
                methodName: "linkKontrol"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    seoTanimlama(tipi,link,seobaslik,seoIcerik,kategori) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                tipi: tipi,
                link: link,
                seobaslik: seobaslik,
                seoIcerik: seoIcerik,
                kategori: kategori,
                methodName: "linkKontrol"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
}

export default seoService

